import type { IAppFeatureResources } from "./AppFeature.Resources";

export const AppFeatureResourcesEn: IAppFeatureResources = {
    GGCForBusinessButton: "Check the details",
};
